import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {FilterBodyTypeIdsSearchValueObject} from './FilterBodyTypeIdsSearchValueObject.js'
import {FilterCategoriesSearchValueObject} from './FilterCategoriesSearchValueObject.js'
import {FilterCityIdSearchValueObject} from './FilterCityIdSearchValueObject.js'
import {FilterCitySearchValueObject} from './FilterCitySearchValueObject.js'
import {FilterColorIdsSearchValueObject} from './FilterColorIdsSearchValueObject.js'
import {FilterCommitmentMonthsSearchValueObject} from './FilterCommitmentMonthsSearchValueObject.js'
import {FilterContractIdSearchValueObject} from './FilterContractIdSearchValueObject.js'
import {FilterCubicCapacitySearchValueObject} from './FilterCubicCapacitySearchValueObject.js'
import {FilterDoorsSearchValueObject} from './FilterDoorsSearchValueObject.js'
import {FilterDrivenWheelsIdsSearchValueObject} from './FilterDrivenWheelsIdsSearchValueObject.js'
import {FilterElectricAutonomySearchValueObject} from './FilterElectricAutonomySearchValueObject.js'
import {FilterElectricBatteryCapacitySearchValueObject} from './FilterElectricBatteryCapacitySearchValueObject.js'
import {FilterElectricChargingTimeFastModeSearchValueObject} from './FilterElectricChargingTimeFastModeSearchValueObject.js'
import {FilterElectricChargingTimeStandardModeSearchValueObject} from './FilterElectricChargingTimeStandardModeSearchValueObject.js'
import {FilterEntrySearchValueObject} from './FilterEntrySearchValueObject.js'
import {FilterEnvironmentalLabelsSearchValueObject} from './FilterEnvironmentalLabelsSearchValueObject.js'
import {FilterEquipmentsSearchValueObject} from './FilterEquipmentsSearchValueObject.js'
import {FilterExcludedVehiclesSearchValueObject} from './FilterExcludedVehiclesSearchValueObject.js'
import {FilterFeeSearchValueObject} from './FilterFeeSearchValueObject.js'
import {FilterFuelTypeIdsSearchValueObject} from './FilterFuelTypeIdsSearchValueObject.js'
import {FilterHasOnlineFinancingSearchValueObject} from './FilterHasOnlineFinancingSearchValueObject.js'
import {FilterHasPhotoSearchValueObject} from './FilterHasPhotoSearchValueObject.js'
import {FilterHasPriceDropSearchValueObject} from './FilterHasPriceDropSearchValueObject.js'
import {FilterHasReservationSearchValueObject} from './FilterHasReservationSearchValueObject.js'
import {FilterHasStockSearchValueObject} from './FilterHasStockSearchValueObject.js'
import {FilterHasWarrantySearchValueObject} from './FilterHasWarrantySearchValueObject.js'
import {FilterHpSearchValueObject} from './FilterHpSearchValueObject.js'
import {FilterInstalmentSearchValueObject} from './FilterInstalmentSearchValueObject.js'
import {FilterIsCertifiedSearchValueObject} from './FilterIsCertifiedSearchValueObject.js'
import {FilterKmSearchValueObject} from './FilterKmSearchValueObject.js'
import {FilterLocationSearchValueObject} from './FilterLocationSearchValueObject.js'
import {FilterLuggageCapacitySearchValueObject} from './FilterLuggageCapacitySearchValueObject.js'
import {FilterMaxTermsSearchValueObject} from './FilterMaxTermsSearchValueObject.js'
import {FilterOfferTypeIdsSearchValueObject} from './FilterOfferTypeIdsSearchValueObject.js'
import {FilterOnlyPeninsulaSearchValueObject} from './FilterOnlyPeninsulaSearchValueObject.js'
import {FilterPriceDropDataSearchValueObject} from './FilterPriceDropDataSearchValueObject.js'
import {FilterPriceRankSearchValueObject} from './FilterPriceRankSearchValueObject.js'
import {FilterPriceSearchValueObject} from './FilterPriceSearchValueObject.js'
import {FilterProvinceIdsSearchValueObject} from './FilterProvinceIdsSearchValueObject.js'
import {FilterRatingSearchValueObject} from './FilterRatingSearchValueObject.js'
import {FilterRegionIdSearchValueObject} from './FilterRegionIdSearchValueObject.js'
import {FilterRegionSearchValueObject} from './FilterRegionSearchValueObject.js'
import {FilterSearchTextSearchValueObject} from './FilterSearchTextSearchValueObject.js'
import {FilterSeatsSearchValueObject} from './FilterSeatsSearchValueObject.js'
import {FilterSellerTypeIdSearchValueObject} from './FilterSellerTypeIdSearchValueObject.js'
import {FilterSubscriptionVehicleStateSearchValueObject} from './FilterSubscriptionVehicleStateSearchValueObject.js'
import {FilterTargetBuyerSearchValueObject} from './FilterTargetBuyerSearchValueObject.js'
import {FilterTransmissionTypeIdSearchValueObject} from './FilterTransmissionTypeIdSearchValueObject.js'
import {FilterVehiclesSearchValueObject} from './FilterVehiclesSearchValueObject.js'
import {FilterYearSearchValueObject} from './FilterYearSearchValueObject.js'

export class FiltersSearchValueObject extends ValueObject {
  #batteryCapacity
  #bodyTypeIds
  #categories
  #chargingTimeFastMode
  #chargingTimeStandardMode
  #city
  #cityId
  #colorIds
  #commitmentMonths
  #contractId
  #cubicCapacity
  #doors
  #drivenWheelsIds
  #electricAutonomy
  #entry
  #environmentalLabels
  #equipments
  #fee
  #fuelTypeIds
  #hasOnlineFinancing
  #hasPhoto
  #hasPriceDrop
  #hasReservation
  #hasStock
  #hasWarranty
  #priceDropData
  #hp
  #instalment
  #isCertified
  #km
  #location
  #luggageCapacity
  #maxTerms
  #offerTypeIds
  #onlyPeninsula
  #price
  #priceRank
  #provinceIds
  #rating
  #region
  #regionId
  #searchText
  #seats
  #sellerTypeId
  #targetBuyer
  #transmissionTypeId
  #subscriptionVehicleState
  #excludedVehicles
  #vehicles
  #year

  constructor({
    batteryCapacity,
    bodyTypeIds,
    categories,
    chargingTimeFastMode,
    chargingTimeStandardMode,
    city,
    cityId,
    colorIds,
    commitmentMonths,
    contractId,
    cubicCapacity,
    doors,
    drivenWheelsIds,
    electricAutonomy,
    entry,
    environmentalLabels,
    equipments,
    fee,
    fuelTypeIds,
    hasOnlineFinancing,
    hasPhoto,
    hasPriceDrop,
    hasReservation,
    hasStock,
    hasWarranty,
    hp,
    instalment,
    isCertified,
    km,
    location,
    luggageCapacity,
    maxTerms,
    offerTypeIds,
    onlyPeninsula,
    price,
    priceDropData,
    priceRank,
    provinceIds,
    rating,
    region,
    regionId,
    searchText,
    seats,
    sellerTypeId,
    targetBuyer,
    transmissionTypeId,
    subscriptionVehicleState,
    excludedVehicles,
    vehicles,
    year
  }) {
    super()
    this.#batteryCapacity = batteryCapacity
    this.#bodyTypeIds = bodyTypeIds
    this.#categories = categories
    this.#chargingTimeFastMode = chargingTimeFastMode
    this.#chargingTimeStandardMode = chargingTimeStandardMode
    this.#city = city
    this.#cityId = cityId
    this.#colorIds = colorIds
    this.#commitmentMonths = commitmentMonths
    this.#contractId = contractId
    this.#cubicCapacity = cubicCapacity
    this.#doors = doors
    this.#drivenWheelsIds = drivenWheelsIds
    this.#electricAutonomy = electricAutonomy
    this.#entry = entry
    this.#environmentalLabels = environmentalLabels
    this.#equipments = equipments
    this.#fee = fee
    this.#fuelTypeIds = fuelTypeIds
    this.#hasOnlineFinancing = hasOnlineFinancing
    this.#hasPhoto = hasPhoto
    this.#hasPriceDrop = hasPriceDrop
    this.#hasReservation = hasReservation
    this.#hasStock = hasStock
    this.#hasWarranty = hasWarranty
    this.#priceDropData = priceDropData
    this.#hp = hp
    this.#instalment = instalment
    this.#isCertified = isCertified
    this.#km = km
    this.#location = location
    this.#luggageCapacity = luggageCapacity
    this.#maxTerms = maxTerms
    this.#offerTypeIds = offerTypeIds
    this.#onlyPeninsula = onlyPeninsula
    this.#price = price
    this.#priceRank = priceRank
    this.#provinceIds = provinceIds
    this.#rating = rating
    this.#region = region
    this.#regionId = regionId
    this.#searchText = searchText
    this.#seats = seats
    this.#sellerTypeId = sellerTypeId
    this.#targetBuyer = targetBuyer
    this.#transmissionTypeId = transmissionTypeId
    this.#subscriptionVehicleState = subscriptionVehicleState
    this.#excludedVehicles = excludedVehicles
    this.#vehicles = vehicles
    this.#year = year
  }

  static create({
    batteryCapacity,
    bodyTypeIds,
    categories,
    chargingTimeFastMode,
    chargingTimeStandardMode,
    city,
    cityId,
    colorIds,
    commitmentMonths,
    contractId,
    cubicCapacity,
    doors,
    drivenWheelsIds,
    electricAutonomy,
    entry,
    environmentalLabels,
    equipments,
    fee,
    fuelTypeIds,
    hasOnlineFinancing,
    hasPhoto,
    hasPriceDrop,
    hasReservation,
    hasStock,
    hasWarranty,
    hp,
    instalment,
    isCertified,
    km,
    location,
    luggageCapacity,
    maxTerms,
    offerTypeIds,
    onlyPeninsula,
    price,
    priceDropData,
    priceRank,
    provinceIds,
    rating,
    region,
    regionId,
    searchText,
    seats,
    sellerTypeId,
    targetBuyer,
    transmissionTypeId,
    subscriptionVehicleState,
    excludedVehicles,
    vehicles,
    year
  }) {
    return new FiltersSearchValueObject({
      batteryCapacity: FilterElectricBatteryCapacitySearchValueObject.create(batteryCapacity),
      bodyTypeIds: FilterBodyTypeIdsSearchValueObject.create(bodyTypeIds),
      categories: FilterCategoriesSearchValueObject.create(categories),
      chargingTimeFastMode: FilterElectricChargingTimeFastModeSearchValueObject.create(chargingTimeFastMode),
      chargingTimeStandardMode:
        FilterElectricChargingTimeStandardModeSearchValueObject.create(chargingTimeStandardMode),
      city: FilterCitySearchValueObject.create(city),
      cityId: FilterCityIdSearchValueObject.create(cityId),
      colorIds: FilterColorIdsSearchValueObject.create(colorIds),
      commitmentMonths: FilterCommitmentMonthsSearchValueObject.create(commitmentMonths),
      contractId: FilterContractIdSearchValueObject.create(contractId),
      cubicCapacity: FilterCubicCapacitySearchValueObject.create(cubicCapacity),
      doors: FilterDoorsSearchValueObject.create(doors),
      drivenWheelsIds: FilterDrivenWheelsIdsSearchValueObject.create(drivenWheelsIds),
      electricAutonomy: FilterElectricAutonomySearchValueObject.create(electricAutonomy),
      entry: FilterEntrySearchValueObject.create(entry),
      environmentalLabels: FilterEnvironmentalLabelsSearchValueObject.create(environmentalLabels),
      equipments: FilterEquipmentsSearchValueObject.create(equipments),
      fee: FilterFeeSearchValueObject.create(fee),
      fuelTypeIds: FilterFuelTypeIdsSearchValueObject.create(fuelTypeIds),
      hasOnlineFinancing: FilterHasOnlineFinancingSearchValueObject.create(hasOnlineFinancing),
      hasPhoto: FilterHasPhotoSearchValueObject.create(hasPhoto),
      hasPriceDrop: FilterHasPriceDropSearchValueObject.create(hasPriceDrop),
      hasReservation: FilterHasReservationSearchValueObject.create(hasReservation),
      hasStock: FilterHasStockSearchValueObject.create(hasStock),
      hasWarranty: FilterHasWarrantySearchValueObject.create(hasWarranty),
      hp: FilterHpSearchValueObject.create(hp),
      instalment: FilterInstalmentSearchValueObject.create(instalment),
      isCertified: FilterIsCertifiedSearchValueObject.create(isCertified),
      km: FilterKmSearchValueObject.create(km),
      location: FilterLocationSearchValueObject.create(location),
      luggageCapacity: FilterLuggageCapacitySearchValueObject.create(luggageCapacity),
      maxTerms: FilterMaxTermsSearchValueObject.create(maxTerms),
      offerTypeIds: FilterOfferTypeIdsSearchValueObject.create(offerTypeIds),
      onlyPeninsula: FilterOnlyPeninsulaSearchValueObject.create(onlyPeninsula),
      price: FilterPriceSearchValueObject.create(price),
      priceDropData: FilterPriceDropDataSearchValueObject.createWithDefault(),
      priceRank: FilterPriceRankSearchValueObject.create(priceRank),
      provinceIds: FilterProvinceIdsSearchValueObject.create(provinceIds),
      rating: FilterRatingSearchValueObject.create(rating),
      region: FilterRegionSearchValueObject.create(region),
      regionId: FilterRegionIdSearchValueObject.create(regionId),
      searchText: FilterSearchTextSearchValueObject.create(searchText),
      seats: FilterSeatsSearchValueObject.create(seats),
      sellerTypeId: FilterSellerTypeIdSearchValueObject.create(sellerTypeId),
      targetBuyer: FilterTargetBuyerSearchValueObject.create(targetBuyer),
      transmissionTypeId: FilterTransmissionTypeIdSearchValueObject.create(transmissionTypeId),
      subscriptionVehicleState: FilterSubscriptionVehicleStateSearchValueObject.create(subscriptionVehicleState),
      excludedVehicles: FilterExcludedVehiclesSearchValueObject.create({excludedVehicles}),
      vehicles: FilterVehiclesSearchValueObject.create(vehicles),
      year: FilterYearSearchValueObject.create(year)
    })
  }

  static createFromApi({config, filters = {}, listingSectionId, url = ''}) {
    return new FiltersSearchValueObject({
      batteryCapacity: FilterElectricBatteryCapacitySearchValueObject.createWithDefaultValue({
        config,
        batteryCapacity: filters.batteryCapacity
      }),
      bodyTypeIds: FilterBodyTypeIdsSearchValueObject.createWithDefaultValue({
        config,
        bodyTypeIds: filters.bodyTypeIds
      }),
      categories: FilterCategoriesSearchValueObject.createFromUrl({
        config,
        categories: filters.categories,
        url
      }),
      chargingTimeFastMode: FilterElectricChargingTimeFastModeSearchValueObject.createWithDefaultValue({
        config,
        chargingTimeFastMode: filters.chargingTimeFastMode
      }),
      chargingTimeStandardMode: FilterElectricChargingTimeStandardModeSearchValueObject.createWithDefaultValue({
        config,
        chargingTimeStandardMode: filters.chargingTimeStandardMode
      }),
      city: FilterCitySearchValueObject.createWithDefaultValue({
        config,
        city: filters.city
      }),
      cityId: FilterCityIdSearchValueObject.createWithDefaultValue({
        config,
        cityId: filters.cityId
      }),
      colorIds: FilterColorIdsSearchValueObject.createWithDefaultValue({
        config,
        colorIds: filters.colorIds
      }),
      commitmentMonths: FilterCommitmentMonthsSearchValueObject.createFromUrl({
        config,
        url
      }),
      contractId: FilterContractIdSearchValueObject.createWithDefaultValue({
        config,
        contractId: filters.contractId
      }),
      cubicCapacity: FilterCubicCapacitySearchValueObject.createWithDefaultValue({
        config,
        cubicCapacity: filters.cubicCapacity
      }),
      doors: FilterDoorsSearchValueObject.createWithDefaultValue({
        config,
        doors: filters.doors
      }),
      drivenWheelsIds: FilterDrivenWheelsIdsSearchValueObject.createWithDefaultValue({
        config,
        drivenWheelsIds: filters.drivenWheelsIds
      }),
      electricAutonomy: FilterElectricAutonomySearchValueObject.createWithDefaultValue({
        config,
        electricAutonomy: filters.electricAutonomy
      }),
      entry: FilterEntrySearchValueObject.createWithDefaultValue({
        config,
        entry: filters.entry
      }),
      environmentalLabels: FilterEnvironmentalLabelsSearchValueObject.createWithDefaultValue({
        config,
        environmentalLabels: filters.environmentalLabels
      }),
      equipments: FilterEquipmentsSearchValueObject.createWithDefaultValue({
        config,
        equipments: filters.equipments
      }),
      fee: FilterFeeSearchValueObject.createFromUrl({
        config,
        url
      }),
      fuelTypeIds: FilterFuelTypeIdsSearchValueObject.createWithDefaultValue({
        config,
        fuelTypeIds: filters.fuelTypeIds
      }),
      hasOnlineFinancing: FilterHasOnlineFinancingSearchValueObject.createWithDefaultValue({
        config,
        hasOnlineFinancing: filters.hasOnlineFinancing
      }),
      hasPhoto: FilterHasPhotoSearchValueObject.createWithDefaultValue({
        config,
        hasPhoto: filters.hasPhoto
      }),
      hasPriceDrop: FilterHasPriceDropSearchValueObject.createWithDefaultValue({
        config,
        hasPriceDrop: filters.priceDrop ? true : null
      }),
      hasReservation: FilterHasReservationSearchValueObject.createWithDefaultValue({
        config,
        hasReservation: filters.hasReservation
      }),
      hasStock: FilterHasStockSearchValueObject.createWithDefaultValue({
        config,
        hasStock: filters.hasStock
      }),
      hasWarranty: FilterHasWarrantySearchValueObject.createWithDefaultValue({
        config,
        hasWarranty: filters.hasWarranty
      }),
      hp: FilterHpSearchValueObject.createWithDefaultValue({
        config,
        hp: filters.hp
      }),
      instalment: FilterInstalmentSearchValueObject.createWithDefaultValue({
        config,
        instalment: filters.instalment
      }),
      isCertified: FilterIsCertifiedSearchValueObject.createWithDefaultValue({
        config,
        isCertified: filters.isCertified
      }),
      km: FilterKmSearchValueObject.createWithDefaultValue({
        config,
        km: filters.km
      }),
      location: FilterLocationSearchValueObject.createWithDefaultValue({
        config,
        location: filters.location
      }),
      luggageCapacity: FilterLuggageCapacitySearchValueObject.createWithDefaultValue({
        config,
        luggageCapacity: filters.luggageCapacity
      }),
      maxTerms: FilterMaxTermsSearchValueObject.createWithDefaultValue({
        config,
        maxTerms: filters.maxTerms
      }),
      offerTypeIds: FilterOfferTypeIdsSearchValueObject.createFromApi({
        config,
        listingSectionId,
        offerTypeIds: filters.offerTypeIds
      }),
      onlyPeninsula: FilterOnlyPeninsulaSearchValueObject.createWithDefaultValue({
        config,
        onlyPeninsula: filters.onlyPeninsula
      }),
      price: FilterPriceSearchValueObject.createWithDefaultValue({
        config,
        price: filters.price
      }),
      priceDropData: filters.priceDrop
        ? FilterPriceDropDataSearchValueObject.create()
        : FilterPriceDropDataSearchValueObject.createWithDefault(),
      priceRank: FilterPriceRankSearchValueObject.createWithDefaultValue({
        config,
        priceRank: filters.priceRank
      }),
      provinceIds: FilterProvinceIdsSearchValueObject.createWithDefaultValue({
        config,
        provinceIds: filters.provinceIds
      }),
      rating: FilterRatingSearchValueObject.createWithDefaultValue({
        config,
        rating: filters.rating
      }),
      region: FilterRegionSearchValueObject.createWithDefaultValue({
        config,
        region: filters.region
      }),
      regionId: FilterRegionIdSearchValueObject.createWithDefaultValue({
        config,
        regionId: filters.regionId
      }),
      searchText: FilterSearchTextSearchValueObject.createWithDefaultValue({
        config,
        searchText: filters.searchText
      }),
      seats: FilterSeatsSearchValueObject.createWithDefaultValue({
        config,
        seats: filters.seats
      }),
      sellerTypeId: FilterSellerTypeIdSearchValueObject.createFromUrl({
        config,
        sellerTypeId: filters.sellerTypeId,
        url
      }),
      targetBuyer: FilterTargetBuyerSearchValueObject.createFromUrl({
        config,
        url
      }),
      transmissionTypeId: FilterTransmissionTypeIdSearchValueObject.createWithDefaultValue({
        config,
        transmissionTypeId: filters.transmissionTypeId
      }),
      subscriptionVehicleState: FilterSubscriptionVehicleStateSearchValueObject.createFromUrl({
        config,
        url
      }),
      excludedVehicles: FilterExcludedVehiclesSearchValueObject.create({excludedVehicles: filters.excludedVehicles}),
      vehicles: FilterVehiclesSearchValueObject.createWithDefaultValue({
        config,
        vehicles: filters.vehicles
      }),
      year: FilterYearSearchValueObject.createWithDefaultValue({
        config,
        year: filters.year
      })
    })
  }

  static createFromFilters({config, filters = {}, listingSectionId}) {
    return new FiltersSearchValueObject({
      batteryCapacity: FilterElectricBatteryCapacitySearchValueObject.createWithDefaultValue({
        config,
        batteryCapacity: filters.batteryCapacity
      }),
      bodyTypeIds: FilterBodyTypeIdsSearchValueObject.createWithDefaultValue({
        config,
        bodyTypeIds: filters.bodyTypeIds
      }),
      categories: FilterCategoriesSearchValueObject.createFromFilters({
        config,
        categoryId: filters.categoryId,
        category2Id: filters.category2Id
      }),
      chargingTimeFastMode: FilterElectricChargingTimeFastModeSearchValueObject.createWithDefaultValue({
        config,
        chargingTimeFastMode: filters.chargingTimeFastMode
      }),
      chargingTimeStandardMode: FilterElectricChargingTimeStandardModeSearchValueObject.createWithDefaultValue({
        config,
        chargingTimeStandardMode: filters.chargingTimeStandardMode
      }),
      city: FilterCitySearchValueObject.createWithDefaultValue({
        config,
        city: filters.city
      }),
      cityId: FilterCityIdSearchValueObject.createWithDefaultValue({
        config,
        cityId: filters.cityId
      }),
      colorIds: FilterColorIdsSearchValueObject.createWithDefaultValue({
        config,
        colorIds: filters.colorIds
      }),
      commitmentMonths: FilterCommitmentMonthsSearchValueObject.createWithDefaultValue({
        config,
        commitmentMonths: filters.commitmentMonths
      }),
      contractId: FilterContractIdSearchValueObject.createWithDefaultValue({
        config,
        contractId: filters.contractId
      }),
      cubicCapacity: FilterCubicCapacitySearchValueObject.createWithDefaultValue({
        config,
        cubicCapacity: filters.litres
      }),
      doors: FilterDoorsSearchValueObject.createWithDefaultValue({
        config,
        doors: filters.doors
      }),
      drivenWheelsIds: FilterDrivenWheelsIdsSearchValueObject.createWithDefaultValue({
        config,
        drivenWheelsIds: filters.drivenWheelsIds
      }),
      electricAutonomy: FilterElectricAutonomySearchValueObject.createWithDefaultValue({
        config,
        electricAutonomy: filters.electricAutonomy
      }),
      entry: FilterEntrySearchValueObject.createWithDefaultValue({
        config,
        hasInstalment: filters.hasInstalment,
        entry: filters.entry
      }),
      environmentalLabels: FilterEnvironmentalLabelsSearchValueObject.createWithDefaultValue({
        config,
        environmentalLabels: filters.environmentalLabels
      }),
      equipments: FilterEquipmentsSearchValueObject.createWithDefaultValue({
        config,
        equipments: filters.equipments
      }),
      fee: FilterFeeSearchValueObject.createWithDefaultValue({
        config,
        price: filters.fee
      }),
      fuelTypeIds: FilterFuelTypeIdsSearchValueObject.createWithDefaultValue({
        config,
        fuelTypeIds: filters.fuelTypeIds
      }),
      hasOnlineFinancing: FilterHasOnlineFinancingSearchValueObject.createWithDefaultValue({
        config,
        hasOnlineFinancing: filters.hasOnlineFinancing
      }),
      hasPhoto: FilterHasPhotoSearchValueObject.createWithDefaultValue({
        config,
        hasPhoto: filters.hasPhoto
      }),
      hasPriceDrop: FilterHasPriceDropSearchValueObject.createWithDefaultValue({
        config,
        hasPriceDrop: filters.hasPriceDrop
      }),
      hasReservation: FilterHasReservationSearchValueObject.createWithDefaultValue({
        config,
        hasReservation: filters.hasReservation
      }),
      hasStock: FilterHasStockSearchValueObject.createWithDefaultValue({
        config,
        hasStock: filters.hasStock
      }),
      hasWarranty: FilterHasWarrantySearchValueObject.createWithDefaultValue({
        config,
        hasWarranty: filters.hasWarranty
      }),
      hp: FilterHpSearchValueObject.createWithDefaultValue({
        config,
        hp: filters.hp
      }),
      instalment: FilterInstalmentSearchValueObject.createWithDefaultValue({
        config,
        hasInstalment: filters.hasInstalment,
        instalment: filters.instalment
      }),
      isCertified: FilterIsCertifiedSearchValueObject.createWithDefaultValue({
        config,
        isCertified: filters.isCertified
      }),
      km: FilterKmSearchValueObject.createWithDefaultValue({
        config,
        km: filters.kms
      }),
      location: FilterLocationSearchValueObject.createWithDefaultValue({
        config,
        location: filters.location
      }),
      luggageCapacity: FilterLuggageCapacitySearchValueObject.createWithDefaultValue({
        config,
        luggageCapacity: filters.luggageCapacity
      }),
      maxTerms: FilterMaxTermsSearchValueObject.createWithDefaultValue({
        config,
        hasInstalment: filters.hasInstalment,
        maxTerms: filters.maxTerms
      }),
      offerTypeIds: FilterOfferTypeIdsSearchValueObject.createFromFilters({
        config,
        filteredOfferTypeId: filters.filteredOfferTypeId,
        listingSectionId,
        offerTypeId: filters.offerTypeId
      }),
      onlyPeninsula: FilterOnlyPeninsulaSearchValueObject.createWithDefaultValue({
        config,
        onlyPeninsula: filters.onlyPeninsula
      }),
      price: FilterPriceSearchValueObject.createWithDefaultValue({
        config,
        price: filters.price
      }),
      priceDropData: filters.hasPriceDrop
        ? FilterPriceDropDataSearchValueObject.create()
        : FilterPriceDropDataSearchValueObject.createWithDefault(),
      priceRank: FilterPriceRankSearchValueObject.createWithDefaultValue({
        config,
        priceRank: filters.priceRank
      }),
      provinceIds: FilterProvinceIdsSearchValueObject.createWithDefaultValue({
        config,
        provinceIds: filters.provinceIds
      }),
      rating: FilterRatingSearchValueObject.createWithDefaultValue({
        config,
        rating: filters.rating
      }),
      region: FilterRegionSearchValueObject.createWithDefaultValue({
        config,
        region: filters.region
      }),
      regionId: FilterRegionIdSearchValueObject.createWithDefaultValue({
        config,
        regionId: filters.regionId
      }),
      searchText: FilterSearchTextSearchValueObject.createWithDefaultValue({
        config,
        searchText: filters.searchText
      }),
      seats: FilterSeatsSearchValueObject.createWithDefaultValue({
        config,
        seats: filters.seats
      }),
      sellerTypeId: FilterSellerTypeIdSearchValueObject.createWithDefaultValue({
        config,
        sellerTypeId: filters.sellerTypeId
      }),
      targetBuyer: FilterTargetBuyerSearchValueObject.createWithDefaultValue({
        config,
        targetBuyer: filters.targetBuyer
      }),
      transmissionTypeId: FilterTransmissionTypeIdSearchValueObject.createWithDefaultValue({
        config,
        transmissionTypeId: filters.transmissionTypeId
      }),
      subscriptionVehicleState: FilterSubscriptionVehicleStateSearchValueObject.createWithDefaultValue({
        vehicleState: filters.subscriptionVehicleState
      }),
      excludedVehicles: FilterExcludedVehiclesSearchValueObject.create({excludedVehicles: filters.excludedVehicles}),
      vehicles: FilterVehiclesSearchValueObject.createFromGroupedModel({
        config,
        vehicles: filters.vehicles
      }),
      year: FilterYearSearchValueObject.createWithDefaultValue({
        config,
        year: filters.year
      })
    })
  }

  static createFromSpecs({config, specs = {}}) {
    return new FiltersSearchValueObject({
      batteryCapacity: FilterElectricBatteryCapacitySearchValueObject.createWithDefaultValue({
        config,
        batteryCapacity: specs.batteryCapacity
      }),
      bodyTypeIds: FilterBodyTypeIdsSearchValueObject.createWithDefaultValue({
        config,
        bodyTypeIds: specs.bodyTypeIds
      }),
      categories: FilterCategoriesSearchValueObject.createFromFilters({
        config,
        categoryId: specs.categoryId,
        category2Id: specs.category2Id
      }),
      chargingTimeFastMode: FilterElectricChargingTimeFastModeSearchValueObject.createWithDefaultValue({
        config,
        chargingTimeFastMode: specs.chargingTimeFastMode
      }),
      chargingTimeStandardMode: FilterElectricChargingTimeStandardModeSearchValueObject.createWithDefaultValue({
        config,
        chargingTimeStandardMode: specs.chargingTimeStandardMode
      }),
      city: FilterCitySearchValueObject.createWithDefaultValue({
        config,
        city: specs.city
      }),
      cityId: FilterCityIdSearchValueObject.createWithDefaultValue({
        config,
        cityId: specs.cityId
      }),
      colorIds: FilterColorIdsSearchValueObject.createWithDefaultValue({
        config,
        colorIds: specs.colorIds
      }),
      commitmentMonths: FilterCommitmentMonthsSearchValueObject.createWithDefaultValue({
        config,
        commitmentMonths: specs.commitmentMonths
      }),
      contractId: FilterContractIdSearchValueObject.createWithDefaultValue({
        config,
        contractId: specs.contractId
      }),
      cubicCapacity: FilterCubicCapacitySearchValueObject.createWithDefaultValue({
        config,
        cubicCapacity: specs.litres
      }),
      doors: FilterDoorsSearchValueObject.createWithDefaultValue({
        config,
        doors: specs.doors
      }),
      drivenWheelsIds: FilterDrivenWheelsIdsSearchValueObject.createWithDefaultValue({
        config,
        drivenWheelsIds: specs.drivenWheelsIds
      }),
      electricAutonomy: FilterElectricAutonomySearchValueObject.createWithDefaultValue({
        config,
        electricAutonomy: specs.electricAutonomy
      }),
      entry: FilterEntrySearchValueObject.createWithDefaultValue({
        config,
        hasInstalment: specs.hasInstalment,
        entry: specs.entry
      }),
      environmentalLabels: FilterEnvironmentalLabelsSearchValueObject.createWithDefaultValue({
        config,
        environmentalLabels: specs.environmentalLabels
      }),
      equipments: FilterEquipmentsSearchValueObject.createWithDefaultValue({
        config,
        equipments: specs.equipments
      }),
      fee: FilterFeeSearchValueObject.createWithDefaultValue({
        config,
        price: specs.fee
      }),
      fuelTypeIds: FilterFuelTypeIdsSearchValueObject.createWithDefaultValue({
        config,
        fuelTypeIds: specs.fuelTypeIds
      }),
      hasOnlineFinancing: FilterHasOnlineFinancingSearchValueObject.createWithDefaultValue({
        config,
        hasOnlineFinancing: specs.hasOnlineFinancing
      }),
      hasPhoto: FilterHasPhotoSearchValueObject.createWithDefaultValue({
        config,
        hasPhoto: specs.hasPhoto
      }),
      hasPriceDrop: FilterHasPriceDropSearchValueObject.createWithDefaultValue({
        config,
        hasPriceDrop: specs.hasPriceDrop
      }),
      hasReservation: FilterHasReservationSearchValueObject.createWithDefaultValue({
        config,
        hasReservation: specs.hasReservation
      }),
      hasStock: FilterHasStockSearchValueObject.createWithDefaultValue({
        config,
        hasStock: specs.hasStock
      }),
      hasWarranty: FilterHasWarrantySearchValueObject.createWithDefaultValue({
        config,
        hasWarranty: specs.hasWarranty
      }),
      hp: FilterHpSearchValueObject.createWithDefaultValue({
        config,
        hp: specs.hp
      }),
      instalment: FilterInstalmentSearchValueObject.createWithDefaultValue({
        config,
        hasInstalment: specs.hasInstalment,
        instalment: specs.instalment
      }),
      isCertified: FilterIsCertifiedSearchValueObject.createWithDefaultValue({
        config,
        isCertified: specs.isCertified
      }),
      km: FilterKmSearchValueObject.createWithDefaultValue({
        config,
        km: specs.kms
      }),
      location: FilterLocationSearchValueObject.createWithDefaultValue({
        config,
        location: specs.location
      }),
      luggageCapacity: FilterLuggageCapacitySearchValueObject.createWithDefaultValue({
        config,
        luggageCapacity: specs.luggageCapacity
      }),
      maxTerms: FilterMaxTermsSearchValueObject.createWithDefaultValue({
        config,
        hasInstalment: specs.hasInstalment,
        maxTerms: specs.maxTerms
      }),
      offerTypeIds: FilterOfferTypeIdsSearchValueObject.createFromFilters({
        config,
        filteredOfferTypeId: specs.filteredOfferTypeId,
        offerTypeId: specs.offerTypeId
      }),
      onlyPeninsula: FilterOnlyPeninsulaSearchValueObject.createWithDefaultValue({
        config,
        onlyPeninsula: specs.onlyPeninsula
      }),
      price: FilterPriceSearchValueObject.createWithDefaultValue({
        config,
        price: specs.price
      }),
      priceDropData: FilterPriceDropDataSearchValueObject.createWithDefault(),
      priceRank: FilterPriceRankSearchValueObject.createWithDefaultValue({
        config,
        priceRank: specs.priceRank
      }),
      provinceIds: FilterProvinceIdsSearchValueObject.createWithDefaultValue({
        config,
        provinceIds: specs.provinceIds
      }),
      rating: FilterRatingSearchValueObject.createWithDefaultValue({
        config,
        rating: specs.rating
      }),
      region: FilterRegionSearchValueObject.createWithDefaultValue({
        config,
        region: specs.region
      }),
      regionId: FilterRegionIdSearchValueObject.createWithDefaultValue({
        config,
        regionId: specs.regionId
      }),
      searchText: FilterSearchTextSearchValueObject.createWithDefaultValue({
        config,
        searchText: specs.searchText
      }),
      seats: FilterSeatsSearchValueObject.createWithDefaultValue({
        config,
        seats: specs.seats
      }),
      sellerTypeId: FilterSellerTypeIdSearchValueObject.createWithDefaultValue({
        config,
        sellerTypeId: specs.sellerTypeId
      }),
      targetBuyer: FilterTargetBuyerSearchValueObject.createWithDefaultValue({
        config,
        targetBuyer: specs.targetBuyer
      }),
      transmissionTypeId: FilterTransmissionTypeIdSearchValueObject.createWithDefaultValue({
        config,
        transmissionTypeId: specs.transmissionTypeId
      }),
      subscriptionVehicleState: FilterSubscriptionVehicleStateSearchValueObject.createWithDefaultValue({
        vehicleState: specs.subscriptionVehicleState
      }),
      excludedVehicles: FilterExcludedVehiclesSearchValueObject.create(),
      vehicles: FilterVehiclesSearchValueObject.createSingleVehicleFromMakeModel({
        config,
        makeId: specs.makeId,
        modelId: specs.modelId
      }),
      year: FilterYearSearchValueObject.createWithDefaultValue({
        config,
        year: specs.year
      })
    })
  }

  static createQueryParams({config, filters, listingSectionId}) {
    return new FiltersSearchValueObject({
      batteryCapacity: FilterElectricBatteryCapacitySearchValueObject.createQueryParams({
        config,
        batteryCapacity: filters.batteryCapacity
      }),
      bodyTypeIds: FilterBodyTypeIdsSearchValueObject.createQueryParams({
        config,
        bodyTypeIds: filters.bodyTypeIds
      }),
      categories: FilterCategoriesSearchValueObject.createQueryParams({
        config,
        categoryId: filters.categoryId,
        category2Id: filters.category2Id
      }),
      chargingTimeFastMode: FilterElectricChargingTimeFastModeSearchValueObject.createQueryParams({
        config,
        chargingTimeFastMode: filters.chargingTimeFastMode
      }),
      chargingTimeStandardMode: FilterElectricChargingTimeStandardModeSearchValueObject.createQueryParams({
        config,
        chargingTimeStandardMode: filters.chargingTimeStandardMode
      }),
      colorIds: FilterColorIdsSearchValueObject.createQueryParams({
        config,
        colorIds: filters.colorIds
      }),
      commitmentMonths: FilterCommitmentMonthsSearchValueObject.createQueryParams({
        config,
        commitmentMonths: filters.commitmentMonths
      }),
      cubicCapacity: FilterCubicCapacitySearchValueObject.createQueryParams({
        config,
        cubicCapacity: filters.litres
      }),
      doors: FilterDoorsSearchValueObject.createQueryParams({
        config,
        doors: filters.doors
      }),
      drivenWheelsIds: FilterDrivenWheelsIdsSearchValueObject.createQueryParams({
        config,
        drivenWheelsIds: filters.drivenWheelsIds
      }),
      electricAutonomy: FilterElectricAutonomySearchValueObject.createQueryParams({
        config,
        electricAutonomy: filters.electricAutonomy
      }),
      entry: FilterEntrySearchValueObject.createQueryParams({
        config,
        entry: filters.entry
      }),
      environmentalLabels: FilterEnvironmentalLabelsSearchValueObject.createQueryParams({
        config,
        environmentalLabels: filters.environmentalLabels
      }),
      equipments: FilterEquipmentsSearchValueObject.createQueryParams({
        config,
        equipments: filters.equipments
      }),
      fee: FilterFeeSearchValueObject.createQueryParams({
        config,
        fee: filters.fee
      }),
      fuelTypeIds: FilterFuelTypeIdsSearchValueObject.createQueryParams({
        config,
        fuelTypeIds: filters.fuelTypeIds
      }),
      hasOnlineFinancing: FilterHasOnlineFinancingSearchValueObject.createQueryParams({
        config,
        hasOnlineFinancing: filters.hasOnlineFinancing
      }),
      hasPhoto: FilterHasPhotoSearchValueObject.createQueryParams({
        config,
        hasPhoto: filters.hasPhoto
      }),
      hasPriceDrop: FilterHasPriceDropSearchValueObject.createQueryParams({
        config,
        hasPriceDrop: filters.hasPriceDrop
      }),
      hasReservation: FilterHasReservationSearchValueObject.createQueryParams({
        config,
        hasReservation: filters.hasReservation
      }),
      hasStock: FilterHasStockSearchValueObject.createQueryParams({
        config,
        hasStock: filters.hasStock
      }),
      hasWarranty: FilterHasWarrantySearchValueObject.createQueryParams({
        config,
        hasWarranty: filters.hasWarranty
      }),
      hp: FilterHpSearchValueObject.createQueryParams({
        config,
        hp: filters.hp
      }),
      instalment: FilterInstalmentSearchValueObject.createQueryParams({
        config,
        hasInstalment: filters.hasInstalment,
        instalment: filters.instalment
      }),
      isCertified: FilterIsCertifiedSearchValueObject.createQueryParams({
        config,
        isCertified: filters.isCertified
      }),
      km: FilterKmSearchValueObject.createQueryParams({
        config,
        km: filters.kms
      }),
      location: FilterLocationSearchValueObject.createQueryParams({
        config,
        location: filters.location
      }),
      luggageCapacity: FilterLuggageCapacitySearchValueObject.createQueryParams({
        config,
        luggageCapacity: filters.luggageCapacity
      }),
      maxTerms: FilterMaxTermsSearchValueObject.createQueryParams({
        config,
        hasInstalment: filters.hasInstalment,
        maxTerms: filters.maxTerms
      }),
      offerTypeIds: FilterOfferTypeIdsSearchValueObject.createQueryParams({
        config,
        filteredOfferTypeId: filters.filteredOfferTypeId,
        listingSectionId,
        offerTypeId: filters.offerTypeId
      }),
      onlyPeninsula: FilterOnlyPeninsulaSearchValueObject.createQueryParams({
        config,
        onlyPeninsula: filters.onlyPeninsula
      }),
      price: FilterPriceSearchValueObject.createQueryParams({
        config,
        price: filters.price
      }),
      priceDropData: FilterPriceDropDataSearchValueObject.createWithDefault(),
      priceRank: FilterPriceRankSearchValueObject.createQueryParams({
        config,
        priceRank: filters.priceRank
      }),
      provinceIds: FilterProvinceIdsSearchValueObject.createQueryParams({
        config,
        provinceIds: filters.provinceIds
      }),
      rating: FilterRatingSearchValueObject.createQueryParams({
        config,
        rating: filters.rating
      }),
      searchText: FilterSearchTextSearchValueObject.createQueryParams({
        config,
        searchText: filters.searchText
      }),
      seats: FilterSeatsSearchValueObject.createQueryParams({
        config,
        seats: filters.seats
      }),
      sellerTypeId: FilterSellerTypeIdSearchValueObject.createQueryParams({
        config,
        sellerTypeId: filters.sellerTypeId
      }),
      targetBuyer: FilterTargetBuyerSearchValueObject.createQueryParams({
        config,
        targetBuyer: filters.targetBuyer
      }),
      transmissionTypeId: FilterTransmissionTypeIdSearchValueObject.createQueryParams({
        config,
        transmissionTypeId: filters.transmissionTypeId
      }),
      subscriptionVehicleState: FilterSubscriptionVehicleStateSearchValueObject.createQueryParams({
        config,
        vehicleState: filters.subscriptionVehicleState
      }),
      excludedVehicles: FilterExcludedVehiclesSearchValueObject.createQueryParams({
        config,
        excludedVehicles: filters.excludedVehicles
      }),
      vehicles: FilterVehiclesSearchValueObject.createQueryParams({
        config,
        vehicles: filters.vehicles
      }),
      year: FilterYearSearchValueObject.createQueryParams({
        config,
        year: filters.year
      })
    })
  }

  static getRelatedListingSectionId({config, categoryId, offerTypeId}) {
    const {LISTING_SECTION_IDS} = config.get('COMMON')
    const {LISTING_SECTION_IDS_BY_CATEGORIES} = config.get('stock')

    const {OFFER_TYPE_SUBSCRIPTION} = config.get('searchFilters')

    return offerTypeId === OFFER_TYPE_SUBSCRIPTION
      ? LISTING_SECTION_IDS.RENTING_VEHICLES
      : LISTING_SECTION_IDS_BY_CATEGORIES[categoryId]
  }

  get batteryCapacity() {
    return this.#batteryCapacity.value
  }

  get bodyTypeIds() {
    return this.#bodyTypeIds.value
  }

  get categories() {
    return this.#categories.value
  }

  get chargingTimeFastMode() {
    return this.#chargingTimeFastMode.value
  }

  get chargingTimeStandardMode() {
    return this.#chargingTimeStandardMode.value
  }

  get colorIds() {
    return this.#colorIds.value
  }

  get commitmentMonths() {
    return this.#commitmentMonths.value
  }

  get contractId() {
    return this.#contractId.value
  }

  get cubicCapacity() {
    return this.#cubicCapacity.value
  }

  get doors() {
    return this.#doors.value
  }

  get drivenWheelsIds() {
    return this.#drivenWheelsIds.value
  }

  get electricAutonomy() {
    return this.#electricAutonomy.value
  }

  get entry() {
    return this.#entry.value
  }

  get environmentalLabels() {
    return this.#environmentalLabels.value
  }

  get equipments() {
    return this.#equipments.value
  }

  get fee() {
    return this.#fee.value
  }

  get fuelTypeIds() {
    return this.#fuelTypeIds.value
  }

  get hasOnlineFinancing() {
    return this.#hasOnlineFinancing.value
  }

  get hasPhoto() {
    return this.#hasPhoto.value
  }

  get hasReservation() {
    return this.#hasReservation.value
  }

  get hasStock() {
    return this.#hasStock.value
  }

  get hasWarranty() {
    return this.#hasWarranty.value
  }

  get hp() {
    return this.#hp.value
  }

  get isCertified() {
    return this.#isCertified.value
  }

  get instalment() {
    return this.#instalment.value
  }

  get km() {
    return this.#km.value
  }

  get location() {
    return this.#location.value
  }

  get luggageCapacity() {
    return this.#luggageCapacity.value
  }

  get maxTerms() {
    return this.#maxTerms.value
  }

  get offerTypeIds() {
    return this.#offerTypeIds.value
  }

  get onlyPeninsula() {
    return this.#onlyPeninsula.value
  }

  get price() {
    return this.#price.value
  }

  get priceRank() {
    return this.#priceRank.value
  }

  get provinceIds() {
    return this.#provinceIds.value
  }

  get rating() {
    return this.#rating.value
  }

  get region() {
    return this.#region.value
  }

  get regionId() {
    return this.#regionId.value
  }

  get searchText() {
    return this.#searchText.value
  }

  get seats() {
    return this.#seats.value
  }

  get sellerTypeId() {
    return this.#sellerTypeId.value
  }

  get targetBuyer() {
    return this.#targetBuyer.value
  }

  get transmissionTypeId() {
    return this.#transmissionTypeId.value
  }

  get subscriptionVehicleState() {
    return this.#subscriptionVehicleState.value
  }

  get excludedVehicles() {
    return this.#excludedVehicles.value
  }

  get vehicles() {
    return this.#vehicles.value
  }

  get year() {
    return this.#year.value
  }

  get hasQueryParams() {
    return Boolean(Object.keys(this.queryParams).length)
  }

  get locationApi() {
    return this.#location.toApi()
  }

  get queryParams() {
    return {
      ...this.#batteryCapacity.queryParams,
      ...this.#bodyTypeIds.queryParams,
      ...this.#categories.queryParams,
      ...this.#chargingTimeFastMode.queryParams,
      ...this.#chargingTimeStandardMode.queryParams,
      ...this.#colorIds.queryParams,
      ...this.#commitmentMonths.queryParams,
      ...this.#cubicCapacity.queryParams,
      ...this.#doors.queryParams,
      ...this.#drivenWheelsIds.queryParams,
      ...this.#electricAutonomy.queryParams,
      ...this.#entry.queryParams,
      ...this.#environmentalLabels.queryParams,
      ...this.#equipments.queryParams,
      ...this.#fee.queryParams,
      ...this.#fuelTypeIds.queryParams,
      ...this.#hasOnlineFinancing.queryParams,
      ...this.#hasPhoto.queryParams,
      ...this.#hasPriceDrop.queryParams,
      ...this.#hasReservation.queryParams,
      ...this.#hasStock.queryParams,
      ...this.#hasWarranty.queryParams,
      ...this.#hp.queryParams,
      ...this.#instalment.queryParams,
      ...this.#isCertified.queryParams,
      ...this.#km.queryParams,
      ...this.#location.queryParams,
      ...this.#luggageCapacity.queryParams,
      ...this.#maxTerms.queryParams,
      ...this.#offerTypeIds.queryParams,
      ...this.#onlyPeninsula.queryParams,
      ...this.#price.queryParams,
      ...this.#priceRank.queryParams,
      ...this.#provinceIds.queryParams,
      ...this.#rating.queryParams,
      ...this.#searchText.queryParams,
      ...this.#seats.queryParams,
      ...this.#sellerTypeId.queryParams,
      ...this.#targetBuyer.queryParams,
      ...this.#transmissionTypeId.queryParams,
      ...this.#subscriptionVehicleState.queryParams,
      ...this.#excludedVehicles.queryParams,
      ...this.#vehicles.queryParams,
      ...this.#year.queryParams
    }
  }

  getSearchForFilters() {
    return {
      batteryCapacity: this.#batteryCapacity.value,
      bodyTypeIds: this.#bodyTypeIds.value,
      categoryId: this.#categories.categoryId,
      category2Id: this.#categories.category2Id,
      chargingTimeFastMode: this.#chargingTimeFastMode.value,
      chargingTimeStandardMode: this.#chargingTimeStandardMode.value,
      city: this.#city.value,
      colorIds: this.#colorIds.value,
      commitmentMonths: this.#commitmentMonths.value,
      contractId: this.#contractId.value,
      doors: this.#doors.value,
      drivenWheelsIds: this.#drivenWheelsIds.value,
      electricAutonomy: this.#electricAutonomy.value,
      entry: this.#entry.value,
      environmentalLabels: this.#environmentalLabels.value,
      equipments: this.#equipments.value,
      fee: this.#fee.value,
      filteredOfferTypeId: this.#offerTypeIds.filteredOfferTypeId,
      fuelTypeIds: this.#fuelTypeIds.value,
      hasInstalment: this.#instalment.hasInstalment,
      hasOnlineFinancing: this.#hasOnlineFinancing.value,
      hasPhoto: this.#hasPhoto.value,
      hasPriceDrop: this.#hasPriceDrop.value,
      hasReservation: this.#hasReservation.value,
      hasStock: this.#hasStock.value,
      hasWarranty: this.#hasWarranty.value,
      hp: this.#hp.value,
      instalment: this.#instalment.value,
      isCertified: this.#isCertified.value,
      kms: this.#km.value,
      litres: this.#cubicCapacity.value,
      location: this.#location.value,
      luggageCapacity: this.#luggageCapacity.value,
      maxTerms: this.#maxTerms.value,
      offerTypeId: this.#offerTypeIds.offerTypeId,
      onlyPeninsula: this.#onlyPeninsula.value,
      price: this.#price.value,
      priceDrop: this.#priceDropData.value,
      priceRank: this.#priceRank.value,
      provinceIds: this.#provinceIds.value,
      rating: this.#rating.value,
      region: this.#region.value,
      regionId: this.#regionId.value,
      searchText: this.#searchText.value,
      seats: this.#seats.value,
      sellerTypeId: this.#sellerTypeId.value,
      targetBuyer: this.#targetBuyer.value,
      transmissionTypeId: this.#transmissionTypeId.value,
      subscriptionVehicleState: this.#subscriptionVehicleState.value,
      excludedVehicles: this.#excludedVehicles.value,
      vehicles: this.#vehicles.valueWithGroupedModel,
      year: this.#year.value
    }
  }

  getSearchFromFilters() {
    return {
      ...(!this.#batteryCapacity.isEmpty && {batteryCapacity: this.#batteryCapacity.value}),
      ...(!this.#bodyTypeIds.isEmpty && {bodyTypeIds: this.#bodyTypeIds.value}),
      ...(!this.#categories.isEmpty && {categories: this.#categories.value}),
      ...(!this.#chargingTimeFastMode.isEmpty && {chargingTimeFastMode: this.#chargingTimeFastMode.value}),
      ...(!this.#chargingTimeStandardMode.isEmpty && {chargingTimeStandardMode: this.#chargingTimeStandardMode.value}),
      ...(!this.#city.isEmpty && {city: this.#city.value}),
      ...(!this.#colorIds.isEmpty && {colorIds: this.#colorIds.value}),
      ...(!this.#commitmentMonths.isEmpty && {commitmentMonths: this.#commitmentMonths.value}),
      ...(!this.#contractId.isEmpty && {contractId: this.#contractId.value}),
      ...(!this.#cubicCapacity.isEmpty && {cubicCapacity: this.#cubicCapacity.value}),
      ...(!this.#doors.isEmpty && {doors: this.#doors.value}),
      ...(!this.#drivenWheelsIds.isEmpty && {drivenWheelsIds: this.#drivenWheelsIds.value}),
      ...(!this.#electricAutonomy.isEmpty && {electricAutonomy: this.#electricAutonomy.value}),
      ...(!this.#entry.isEmpty && {entry: this.#entry.value}),
      ...(!this.#environmentalLabels.isEmpty && {environmentalLabels: this.#environmentalLabels.value}),
      ...(!this.#equipments.isEmpty && {equipments: this.#equipments.value}),
      ...(!this.#fee.isEmpty && {fee: this.#fee.value}),
      ...(!this.#fuelTypeIds.isEmpty && {fuelTypeIds: this.#fuelTypeIds.value}),
      ...(!this.#hasOnlineFinancing.isEmpty && {hasOnlineFinancing: this.#hasOnlineFinancing.value}),
      ...(!this.#hasPhoto.isEmpty && {hasPhoto: this.#hasPhoto.value}),
      ...(!this.#hasPriceDrop.isEmpty && {hasPriceDrop: this.#hasPriceDrop.value}),
      ...(!this.#hasReservation.isEmpty && {hasReservation: this.#hasReservation.value}),
      ...(!this.#hasStock.isEmpty && {hasStock: this.#hasStock.value}),
      ...(!this.#hasWarranty.isEmpty && {hasWarranty: this.#hasWarranty.value}),
      ...(!this.#hp.isEmpty && {hp: this.#hp.value}),
      ...(!this.#instalment.isEmpty && {instalment: this.#instalment.value}),
      ...(!this.#isCertified.isEmpty && {isCertified: this.#isCertified.value}),
      ...(!this.#km.isEmpty && {km: this.#km.value}),
      ...(!this.#location.isEmpty && {location: this.#location.value}),
      ...(!this.#luggageCapacity.isEmpty && {luggageCapacity: this.#luggageCapacity.value}),
      ...(!this.#maxTerms.isEmpty && {maxTerms: this.#maxTerms.value}),
      ...(!this.#offerTypeIds.isEmpty && {offerTypeIds: this.#offerTypeIds.offerTypeIds}),
      ...(!this.#onlyPeninsula.isEmpty && {onlyPeninsula: this.#onlyPeninsula.value}),
      ...(!this.#price.isEmpty && {price: this.#price.value}),
      ...(!this.#priceDropData.isEmpty && {priceDrop: this.#priceDropData.value}),
      ...(!this.#priceRank.isEmpty && {priceRank: this.#priceRank.value}),
      ...(!this.#provinceIds.isEmpty && {provinceIds: this.#provinceIds.value}),
      ...(!this.#rating.isEmpty && {rating: this.#rating.value}),
      ...(!this.#searchText.isEmpty && {searchText: this.#searchText.value}),
      ...(!this.#seats.isEmpty && {seats: this.#seats.value}),
      ...(!this.#sellerTypeId.isEmpty && {sellerTypeId: this.#sellerTypeId.value}),
      ...(!this.#targetBuyer.isEmpty && {targetBuyer: this.#targetBuyer.value}),
      ...(!this.#transmissionTypeId.isEmpty && {transmissionTypeId: this.#transmissionTypeId.value}),
      ...(!this.#subscriptionVehicleState.isEmpty && {subscriptionVehicleState: this.#subscriptionVehicleState.value}),
      ...(!this.#excludedVehicles.isEmpty && {excludedVehicles: this.#excludedVehicles.valueToApi}),
      ...(!this.#vehicles.isEmpty && {vehicles: this.#vehicles.value}),
      ...(!this.#year.isEmpty && {year: this.#year.value})
    }
  }

  getSearchForStockAggregations() {
    const {DEFAULT_REQUEST_OFFER_TYPE_IDS_BY_LISTING_SECTION_ID, OFFER_TYPES_IDS} =
      ConfigContext.get('vehicleSpecifications')

    const {LISTING_SECTION_IDS} = ConfigContext.get('COMMON')

    const filters = this.getSearchFromFilters()

    const [selectedOfferTypeId] = filters.offerTypeIds || []

    return {
      contractId: filters.contractId,
      offerTypeIds:
        String(selectedOfferTypeId) === OFFER_TYPES_IDS.SUBSCRIPTION
          ? DEFAULT_REQUEST_OFFER_TYPE_IDS_BY_LISTING_SECTION_ID[LISTING_SECTION_IDS.RENTING_VEHICLES]
          : DEFAULT_REQUEST_OFFER_TYPE_IDS_BY_LISTING_SECTION_ID[LISTING_SECTION_IDS.ALL_VEHICLES]
    }
  }

  get value() {
    return {
      batteryCapacity: this.#batteryCapacity.value,
      bodyTypeIds: this.#bodyTypeIds.value,
      categories: this.#categories.value,
      chargingTimeFastMode: this.#chargingTimeFastMode.value,
      chargingTimeStandardMode: this.#chargingTimeStandardMode.value,
      city: this.#city.value,
      cityId: this.#cityId.value,
      colorIds: this.#colorIds.value,
      commitmentMonths: this.#commitmentMonths.value,
      contractId: this.#contractId.value,
      cubicCapacity: this.#cubicCapacity.value,
      doors: this.#doors.value,
      drivenWheelsIds: this.#drivenWheelsIds.value,
      electricAutonomy: this.#electricAutonomy.value,
      entry: this.#entry.value,
      environmentalLabels: this.#environmentalLabels.value,
      equipments: this.#equipments.value,
      fee: this.#fee.value,
      fuelTypeIds: this.#fuelTypeIds.value,
      hasOnlineFinancing: this.#hasOnlineFinancing.value,
      hasPhoto: this.#hasPhoto.value,
      hasPriceDrop: this.#hasPriceDrop.value,
      hasReservation: this.#hasReservation.value,
      hasStock: this.#hasStock.value,
      hasWarranty: this.#hasWarranty.value,
      hp: this.#hp.value,
      instalment: this.#instalment.value,
      isCertified: this.#isCertified.value,
      km: this.#km.value,
      location: this.#location.value,
      luggageCapacity: this.#luggageCapacity.value,
      maxTerms: this.#maxTerms.value,
      offerTypeIds: this.#offerTypeIds.value,
      onlyPeninsula: this.#onlyPeninsula.value,
      price: this.#price.value,
      priceDropData: this.#priceDropData.value,
      priceRank: this.#priceRank.value,
      provinceIds: this.#provinceIds.value,
      rating: this.#rating.value,
      region: this.#region.value,
      regionId: this.#regionId.value,
      searchText: this.#searchText.value,
      seats: this.#seats.value,
      sellerTypeId: this.#sellerTypeId.value,
      targetBuyer: this.#targetBuyer.value,
      transmissionTypeId: this.#transmissionTypeId.value,
      subscriptionVehicleState: this.#subscriptionVehicleState.value,
      excludedVehicles: this.#excludedVehicles.value,
      vehicles: this.#vehicles.value,
      year: this.#year.value
    }
  }

  toJSON() {
    return {
      batteryCapacity: this.#batteryCapacity.toJSON(),
      bodyTypeIds: this.#bodyTypeIds.toJSON(),
      categories: this.#categories.toJSON(),
      chargingTimeFastMode: this.#chargingTimeFastMode.toJSON(),
      chargingTimeStandardMode: this.#chargingTimeStandardMode.toJSON(),
      city: this.#city.toJSON(),
      cityId: this.#cityId.toJSON(),
      colorIds: this.#colorIds.toJSON(),
      commitmentMonths: this.#commitmentMonths.toJSON(),
      contractId: this.#contractId.toJSON(),
      cubicCapacity: this.#cubicCapacity.toJSON(),
      doors: this.#doors.toJSON(),
      drivenWheelsIds: this.#drivenWheelsIds.toJSON(),
      electricAutonomy: this.#electricAutonomy.toJSON(),
      entry: this.#entry.toJSON(),
      environmentalLabels: this.#environmentalLabels.toJSON(),
      equipments: this.#equipments.toJSON(),
      fee: this.#fee.toJSON(),
      fuelTypeIds: this.#fuelTypeIds.toJSON(),
      hasOnlineFinancing: this.#hasOnlineFinancing.toJSON(),
      hasPhoto: this.#hasPhoto.toJSON(),
      hasPriceDrop: this.#hasPriceDrop.toJSON(),
      hasReservation: this.#hasReservation.toJSON(),
      hasStock: this.#hasStock.toJSON(),
      hasWarranty: this.#hasWarranty.toJSON(),
      hp: this.#hp.toJSON(),
      instalment: this.#instalment.toJSON(),
      isCertified: this.#isCertified.toJSON(),
      km: this.#km.toJSON(),
      location: this.#location.toJSON(),
      luggageCapacity: this.#luggageCapacity.toJSON(),
      maxTerms: this.#maxTerms.toJSON(),
      offerTypeIds: this.#offerTypeIds.toJSON(),
      onlyPeninsula: this.#onlyPeninsula.toJSON(),
      price: this.#price.toJSON(),
      priceDropData: this.#priceDropData.toJSON(),
      priceRank: this.#priceRank.toJSON(),
      provinceIds: this.#provinceIds.toJSON(),
      rating: this.#rating.toJSON(),
      region: this.#region.toJSON(),
      regionId: this.#regionId.toJSON(),
      searchText: this.#searchText.toJSON(),
      seats: this.#seats.toJSON(),
      sellerTypeId: this.#sellerTypeId.toJSON(),
      targetBuyer: this.#targetBuyer.toJSON(),
      transmissionTypeId: this.#transmissionTypeId.toJSON(),
      subscriptionVehicleState: this.#subscriptionVehicleState.toJSON(),
      excludedVehicles: this.#excludedVehicles.toJSON(),
      vehicles: this.#vehicles.toJSON(),
      year: this.#year.toJSON()
    }
  }
}
